import { Action } from '@ngrx/store';
import { Reference } from 'src/app/core/utils/action-helper.util';
import { Error } from '../../_models/auth.models';
import {
  CopyDashboardPayload,
  CopyDashboardResponse,
} from '../../_models/page.model';
import { SummaryField } from '../../_models/settings.models';

/**
 * Dashboard action types
 */
export enum DashboardActionTypes {
  LOAD_DASHBOARD = '[Dashboard] Load Dashboard',
  LOAD_DASHBOARD_SUCCESS = '[Dashboard] Load Dashboard Success',
  LOAD_DASHBOARD_FAILED = '[Dashboard] Load Dashboard Failed',
  LOAD_DASHBOARDS = '[Dashboard] Load Dashboards',
  LOAD_DASHBOARDS_SUCCESS = '[Dashboard] Load Dashboards Success',
  LOAD_DASHBOARDS_FAILED = '[Dashboard] Load Dashboards Failed',
  LOAD_SUMMARY_FIELDS = '[Dashboard] Load Summary Fields',
  LOAD_SUMMARY_FIELDS_SUCCESS = '[Dashboard] Load Summary Fields Success',
  LOAD_SUMMARY_FIELDS_FAILED = '[Dashboard] Load Summary Fields Failed',
  LOAD_DATABASE_REPORTS = '[Dashboard] Load Database Reports',
  LOAD_DATABASE_REPORTS_SUCCESS = '[Dashboard] Load Database Reports Success',
  LOAD_DATABASE_REPORTS_FAILED = '[Dashboard] Load Database Reports Failed',
  LOAD_SUMMARY_REPORTS = '[Dashboard] Load Summary Reports',
  LOAD_SUMMARY_REPORTS_SUCCESS = '[Dashboard] Load Summary Reports Success',
  LOAD_SUMMARY_REPORTS_FAILED = '[Dashboard] Load Summary Reports Failed',
  SAVE_DASHBOARD = '[Dashboard] Save Dashboard',
  SAVE_DASHBOARD_SUCCESS = '[Dashboard] Save Dashboard Success',
  SAVE_DASHBOARD_FAILED = '[Dashboard] Save Dashboard Failed',
  UPDATE_DASHBOARD = '[Dashboard] Update Dashboard',
  UPDATE_DASHBOARD_SUCCESS = '[Dashboard] Update Dashboard Success',
  UPDATE_DASHBOARD_FAILED = '[Dashboard] Update Dashboard Failed',
  DELETE_DASHBOARD = '[Dashboard] Delete Dashbaord',
  DELETE_DASHBOARD_SUCCESS = '[Dashboard] Delete Dashbaord Success',
  DELETE_DASHBOARD_FAILED = '[Dashboard] Delete Dashbaord Failed',
  LOAD_SUMMARY_FIELD_VALUE = '[Dashboard] Load Summary Field Value',
  LOAD_SUMMARY_FIELD_VALUE_SUCCESS = '[Dashboard] Load Summary Field Value Success',
  LOAD_SUMMARY_FIELD_VALUE_FAILED = '[Dashboard] Load Summary Field Value Failed',
  LOAD_REPORTS_BY_TYPE = '[Dashboard] Load Reports By Type',
  LOAD_REPORTS_BY_TYPE_SUCCESS = '[Dashboard] Load Reports By Type Success',
  LOAD_REPORTS_BY_TYPE_FAILED = '[Dashboard] Load Reports By Type Failed',
  COPY_DASHBOARD = '[Dashboard] Copy Dashboard',
  COPY_DASHBOARD_SUCCESS = '[Dashboard] Copy Dashboard Success',
  COPY_DASHBOARD_FAILED = '[Dashboard] Copy Dashboard Failed',
  RESET_DASHBOARD_DETAILS = '[Dashboard] Reset Dashboard Details',
  RESET = '[Dashboard] RESET',
}

/**
 * Operations
 */

export class CopyDashboard extends Reference implements Action {
  readonly type = DashboardActionTypes.COPY_DASHBOARD;

  constructor(public appId: string, public payload: CopyDashboardPayload) {
    super();
  }
}

export class CopyDashboardSuccess extends Reference implements Action {
  readonly type = DashboardActionTypes.COPY_DASHBOARD_SUCCESS;

  constructor(public payload: CopyDashboardResponse) {
    super();
  }
}

export class CopyDashboardFailed extends Reference implements Action {
  readonly type = DashboardActionTypes.COPY_DASHBOARD_FAILED;

  constructor(public payload: Error) {
    super();
  }
}

export class LoadDashboards implements Action {
  readonly type = DashboardActionTypes.LOAD_DASHBOARDS;

  /**
   * @param force to forcefully fetch, regardless of caching enabled
   */
  constructor(public applicationId: string, public force: boolean = false) {}
}

export class LoadDashboardsSuccess implements Action {
  readonly type = DashboardActionTypes.LOAD_DASHBOARDS_SUCCESS;

  constructor(public applicationId: string, public payload: Array<any>) {}
}

export class LoadDashboardsFailed implements Action {
  readonly type = DashboardActionTypes.LOAD_DASHBOARDS_FAILED;

  constructor(public payload: Error, public applicationId:string) {}
}

export class LoadDashboard implements Action {
  readonly type = DashboardActionTypes.LOAD_DASHBOARD;

  /**
   * @param force to forcefully fetch, regardless of caching enabled
   */
  constructor(public applicationId: string, public dashboardId: string, public force: boolean = false) {}
}

export class LoadDashboardSuccess implements Action {
  readonly type = DashboardActionTypes.LOAD_DASHBOARD_SUCCESS;

  constructor(public applicationId: string,public dashboardId:string, public payload: any) {}
}

export class LoadDashboardFailed implements Action {
  readonly type = DashboardActionTypes.LOAD_DASHBOARD_FAILED;

  constructor(public payload: Error) {}
}

export class LoadSummaryFields implements Action {
  readonly type = DashboardActionTypes.LOAD_SUMMARY_FIELDS;

  constructor(public appId: any) {}
}

export class LoadSummaryFieldsSuccess implements Action {
  readonly type = DashboardActionTypes.LOAD_SUMMARY_FIELDS_SUCCESS;

  constructor(public appId: string, public payload: any) {}
}

export class LoadSummaryFieldsFailed implements Action {
  readonly type = DashboardActionTypes.LOAD_SUMMARY_FIELDS_FAILED;

  constructor(public payload: any, public appId: string) {}
}

export class LoadDatabaseReports implements Action {
  readonly type = DashboardActionTypes.LOAD_DATABASE_REPORTS;

  constructor(public appId: string) {}
}

export class LoadDatabaseReportsSuccess implements Action {
  readonly type = DashboardActionTypes.LOAD_DATABASE_REPORTS_SUCCESS;

  constructor(public appId: string, public payload: any) {}
}

export class LoadDatabaseReportsFailed implements Action {
  readonly type = DashboardActionTypes.LOAD_DATABASE_REPORTS_FAILED;

  constructor(public payload: any, public appId: string) {}
}

export class LoadSummaryReports implements Action {
  readonly type = DashboardActionTypes.LOAD_SUMMARY_REPORTS;

  constructor(public appId: any) {}
}

export class LoadSummaryReportsSuccess implements Action {
  readonly type = DashboardActionTypes.LOAD_SUMMARY_REPORTS_SUCCESS;

  constructor(public appId: string, public payload: any) {}
}

export class LoadSummaryReportsFailed implements Action {
  readonly type = DashboardActionTypes.LOAD_SUMMARY_REPORTS_FAILED;

  constructor(public payload: any, public appId: string) {}
}

export class SaveDashboad extends Reference implements Action {
  readonly type = DashboardActionTypes.SAVE_DASHBOARD;

  constructor(public appId: string, public payload: any) {
    super();
  }
}

export class SaveDashboadSuccess extends Reference implements Action {
  readonly type = DashboardActionTypes.SAVE_DASHBOARD_SUCCESS;

  constructor(public appId: string, public payload: any) {
    super();
  }
}

export class SaveDashboadFailed extends Reference implements Action {
  readonly type = DashboardActionTypes.SAVE_DASHBOARD_FAILED;

  constructor(public payload: any) {
    super();
  }
}

export class UpdateDashboard extends Reference implements Action {
  readonly type = DashboardActionTypes.UPDATE_DASHBOARD;

  constructor(
    public appId: string,
    public dashboardId: string,
    public payload: any
  ) {
    super();
  }
}

export class UpdateDashboardSuccess extends Reference implements Action {
  readonly type = DashboardActionTypes.UPDATE_DASHBOARD_SUCCESS;

  constructor(
    public appId: string,
    public dashboardId: string,
    public payload: any
  ) {
    super();
  }
}

export class UpdateDashboardFailed extends Reference implements Action {
  readonly type = DashboardActionTypes.UPDATE_DASHBOARD_FAILED;

  constructor(public payload: any) {
    super();
  }
}
export class DeleteDashboard implements Action {
  readonly type = DashboardActionTypes.DELETE_DASHBOARD;

  constructor(public appId: string, public dashboardId: string) {}
}

export class DeleteDashboardSuccess implements Action {
  readonly type = DashboardActionTypes.DELETE_DASHBOARD_SUCCESS;

  constructor(public appId: string, public dashboardId: string) {}
}

export class DeleteDashboardFailed implements Action {
  readonly type = DashboardActionTypes.DELETE_DASHBOARD_FAILED;

  constructor(public payload: any) {}
}

export class LoadSummaryFieldValue implements Action {
  readonly type = DashboardActionTypes.LOAD_SUMMARY_FIELD_VALUE;

  constructor(
    public appId: string,
    public summaryFieldId: number,
    public force: boolean = false
  ) {}
}

export class LoadSummaryFieldValueSuccess implements Action {
  readonly type = DashboardActionTypes.LOAD_SUMMARY_FIELD_VALUE_SUCCESS;

  constructor(
    public appId: string,
    public summaryFieldId: number,
    public payload: SummaryField
  ) {}
}

export class LoadSummaryFieldValueFailed implements Action {
  readonly type = DashboardActionTypes.LOAD_SUMMARY_FIELD_VALUE_FAILED;

  constructor(public payload: Error) {}
}

export class LoadReportsByType implements Action {
  readonly type = DashboardActionTypes.LOAD_REPORTS_BY_TYPE;

  constructor(
    public appId: string,
    public reportType: 'map' | 'gantt' | 'calendar'
  ) {}
}

export class LoadReportsByTypeSuccess implements Action {
  readonly type = DashboardActionTypes.LOAD_REPORTS_BY_TYPE_SUCCESS;

  constructor(
    public appId: string,
    public reportType: 'map' | 'gantt' | 'calendar',
    public payload: any
  ) {}
}

export class LoadReportsByTypeFailed implements Action {
  readonly type = DashboardActionTypes.LOAD_REPORTS_BY_TYPE_FAILED;

  constructor(public payload: any, public appId: string) {}
}

export class Reset implements Action {
  readonly type = DashboardActionTypes.RESET;

  constructor() {}
}
export class ResetDashboardDetails implements Action {
  readonly type = DashboardActionTypes.RESET_DASHBOARD_DETAILS;

  constructor() {}
}

/**
 * Available types
 */
export type Actions =
  | LoadDashboard
  | LoadDashboardSuccess
  | LoadDashboardFailed
  | LoadSummaryFields
  | LoadSummaryFieldsSuccess
  | LoadSummaryFieldsFailed
  | LoadDatabaseReports
  | LoadDatabaseReportsSuccess
  | LoadDatabaseReportsFailed
  | LoadSummaryReports
  | LoadSummaryReportsSuccess
  | LoadSummaryReportsFailed
  | SaveDashboad
  | SaveDashboadSuccess
  | SaveDashboadFailed
  | UpdateDashboard
  | UpdateDashboardSuccess
  | UpdateDashboardFailed
  | DeleteDashboard
  | DeleteDashboardSuccess
  | DeleteDashboardFailed
  | LoadSummaryFieldValue
  | LoadSummaryFieldValueSuccess
  | LoadSummaryFieldValueFailed
  | LoadReportsByType
  | LoadReportsByTypeSuccess
  | LoadReportsByTypeFailed
  | CopyDashboard
  | CopyDashboardSuccess
  | CopyDashboardFailed
  | LoadDashboards
  | LoadDashboardsSuccess
  | LoadDashboardsFailed
  | ResetDashboardDetails
  | Reset;
